import { t } from "@repo/translation";
import { FilterCheckbox } from "@repo/ui";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const WaitingListFilter = ({ actions, filters }: FilterItemsProps) => {
  return (
    <FilterListContainer id="waiting-list-filter">
      <FilterCheckbox
        id={filters.waitingList}
        value="waiting_list"
        label={t("label.waiting_list")}
        checked={filters.waitingList === true}
        onCheckFilter={(_, checked) => {
          if (checked) {
            actions.setWaitingList(true);
            return;
          }

          actions.setWaitingList(undefined);
        }}
      />
    </FilterListContainer>
  );
};
